export const env = {
    REACT_APP_EMAILJS_SERVICEID: 'gmail',
    REACT_APP_EMAILJS_TEMPLATEID: 'template_yIMujpd8',
    REACT_APP_EMAILJS_USERID:   'user_oNEwY39ehCfptAGh7neg6' ,
  };